import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from "@mui/material";

import { getsRol } from "../../services/seguridadService";
import DataGridBase from "../../components/common/DataGridBase";
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Listado de roles. Cada rol tiene sus accesos, que se asignan desde la
// pantalla de edicion.
const Role = () => {
    const { isReadOnly } = useMantenimiento("rol");
    const navigate = useNavigate();

    const [results, setResults] = useState([]);
    const [cargando, setCargando] = useState(true);

    const fetchResults = useCallback(async () => {
        setCargando(true);

        const data = await getsRol().catch((err) => { console.log("Err: ", err) });

        // El grid pide un id unico por fila.
        setResults((data || []).map((row) => ({ ...row, id: row.id })));
        setCargando(false);
    }, [])

    useEffect(() => {
        fetchResults();
    }, [fetchResults])

    const columns = [
        { field: 'id', headerName: 'Id', width: 60, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => (
                <Box sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => navigate("/security/role/edit/" + cellValues.row.id)}>
                    {cellValues.row.id}
                </Box>
            )
        },
        { field: 'nombre', headerName: 'Rol', width: 200, sortable: false, headerAlign: 'left' },
        { field: 'descripcion', headerName: 'Descripcion', width: 260, sortable: false, headerAlign: 'left' },
        { field: 'estado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center'
            , valueGetter: (value, row) => row.idEstado == 2 ? "Activo" : "Inactivo"
        },
    ];

    return (
        <div>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                Roles
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', paddingTop: "12px" }}>
                <DataGridBase rows={results} columns={columns} loading={cargando} disabled={isReadOnly} />
            </Box>
        </div>
    )
}

export default Role;
